import React from 'react'
import "@Styles/mandate.css";
import arrowleft from "../../../Images/NewUI/Vector.png";

const ViewDetails = () => {
  return (
    <div className=" payme_body ">
        <div  className="container">
        <h3 className='loandetailss'>Loan <span style={{color: "rgba(252, 102, 3, 1)"}}>Details</span></h3>
    
        <div className=" aligncentrehere container">
            <p className='loanstatement '>Loan Statement</p>
              <div className="cardstructurevd  container">
              <div className="justifycontentSpacebetn flex_row managemargin paddingviewdetails ">
                  <span className="gray_text mt-10"> Sanctioned amount</span>
                  <span>₹8000</span>
                </div>
                <div className="justifycontentSpacebetn flex_row managemargin">
                  <span className="gray_text mt-10"> Interest (per day)</span>
                  <span>0.10%</span>
                </div>
                <div className="justifycontentSpacebetn flex_row managemargin">
                  <span className="gray_text mt-10"> Tenure days</span>
                  <span>100</span>
                </div>
                <div className="justifycontentSpacebetn flex_row managemargin">
                  <span className="gray_text mt-10"> Processing fee</span>
                  <span>₹472</span>
                </div>
                <div className="justifycontentSpacebetn flex_row managemargin">
                  <span className="gray_text mt-10"> Collection Amount</span>
                  <span>₹8484</span>
                </div>
                <div className="justifycontentSpacebetn flex_row managemargin">
                  <span className="gray_text mt-10"> Collection Date</span>
                  <span>25-10-2022</span>
                </div>
              </div>
        </div>


        <div style={{marginTop:22}} className=" aligncentrehere container ">
            <p className='loanstatement '>EMI Details</p>
              <div className="cardstructurevd  container">
              <div className="justifycontentSpacebetn flex_row managemargin paddingviewdetails ">
                  <span className="gray_text mt-10"> Sanctioned amount</span>
                  <span>₹8000</span>
                </div>
                <div className="justifycontentSpacebetn flex_row managemargin">
                  <span className="gray_text mt-10"> Interest (per day)</span>
                  <span>0.10%</span>
                </div>
                <div className="justifycontentSpacebetn flex_row managemargin">
                  <span className="gray_text mt-10"> Tenure days</span>
                  <span>100</span>
                </div>
                <div className="justifycontentSpacebetn flex_row managemargin">
                  <span className="gray_text mt-10"> Processing fee</span>
                  <span>₹472</span>
                </div>
                <div className="justifycontentSpacebetn flex_row managemargin">
                  <span className="gray_text mt-10"> Collection Amount</span>
                  <span>₹8484</span>
                </div>
                <div className="justifycontentSpacebetn flex_row managemargin">
                  <span className="gray_text mt-10"> Collection Date</span>
                  <span>25-10-2022</span>
                </div>
                
              </div>
              
        </div>

              <div className="marginTop displayfixx ">
                <span className="">
                <img className="arrowbtnpaddingviewdetail" style={{cursor:"pointer"}}  src={arrowleft}  onClick={() => {
                window.location.href="/dashboard_s"}} />
                </span>
              <div className="GetNowBtnrepayvd"  >Repay Now</div>
              </div>
        </div>
    </div>
  )
}

export default ViewDetails